import { findElementById } from '../Utils';

export function shareLink(): void {
    const $shareButton = findElementById('shareButton');

    function onShareClick() {
        const currentURL = window.location.href;

        navigator.clipboard.writeText(currentURL).then(function () {
            showToaster("Länk Kopierad!");
        }, function (err) {
            console.error('Could not copy text: ', err);
        });
    }

    // Define the showToaster function with TypeScript types
    function showToaster(message: string, duration: number = 3000): void {
        // Get the toaster and message elements with type casting
        const toaster = document.getElementById("toaster") as HTMLElement | null;
        const toasterMessage = document.getElementById("toasterMessage") as HTMLElement | null;

        if (toaster && toasterMessage) {
            // Set the message text
            toasterMessage.textContent = message;

            // Show the toaster by adding/removing Tailwind classes
            toaster.classList.remove("hidden");
            toaster.classList.add("opacity-100");

            // Hide the toaster after the specified duration
            setTimeout(() => {
                toaster.classList.add("hidden");
            }, duration);
        } else {
            console.warn("Toaster element not found");
        }
    }

    $shareButton?.addEventListener('click', onShareClick, false);
}
